import { Link, Text } from "@simplybusiness/mobius";
import { SkeletonTheme } from "react-loading-skeleton";
import { useLocale } from "../../hooks/useLocale";
import { StyledSkeleton } from "../QuoteCards/QuotesSkeleton";
import type { HeadlineProps } from "./types";

export const HeadlineSkeleton = ({ quoteCount }: HeadlineProps) => {
  const { isUK } = useLocale();

  return (
    <div className="mobius-quote-headline">
      <SkeletonTheme
        baseColor="var(--color-background-light)"
        highlightColor="var(--color-background)"
      >
        {isUK ? (
          quoteCount === 0 ? (
            <div
              className="mobius-quote-headline__no-quotes-title"
              style={{ display: "block", textAlign: "center" }}
            >
              <StyledSkeleton width="30%" />
            </div>
          ) : (
            <div
              className="mobius-quote-headline__text"
              style={{ height: "122px" /* Fix div height to match Text */ }}
            >
              <StyledSkeleton />
              <StyledSkeleton width="50%" />
              <div className="mobius-quote-headline__text mobius-quote-headline__text--variant-without-qdp-drawer">
                <StyledSkeleton width="65%" />
                <StyledSkeleton width="40%" />
              </div>
            </div>
          )
        ) : (
          <>
            <Link
              style={{ display: "block" }}
              className="mobius-quote-headline__link"
            >
              <StyledSkeleton width="8%" />
            </Link>
            <Text className="mobius-quote-headline__title">
              <StyledSkeleton width="42%" />
            </Text>
            <Text className="mobius-quote-headline__description">
              <StyledSkeleton width="55%" />
            </Text>
          </>
        )}
      </SkeletonTheme>
    </div>
  );
};
